import { Component, ElementRef, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { LoyaltyImportGiftService } from 'app/services/loyalty/loyalty-import-gift.service';
import { FileExport, HeadImport } from 'app/models/import-gift.model';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/primeng';
import { KoncentroValidators } from 'app/modules/UIKit/validators/koncentro-validators';

type AOA = FileExport[];
@Component({
  selector: 'app-loyalty-import-gift-detail',
  templateUrl: './loyalty-import-gift-detail.component.html',
  styleUrls: ['./loyalty-import-gift-detail.component.css']
})
export class LoyaltyImportGiftDetailComponent implements OnInit {
  @ViewChild('choose') choose: ElementRef;

  importGiftFields: any;
  invalidSubmit: boolean;
  form: FormGroup
  giftFile: File = null;
  giftData: AOA;
  headImport: HeadImport = { };
  fileName: string;
  imageFile: File[] = [];
  imagesNotPresent: boolean;

  constructor(
    private importService: LoyaltyImportGiftService,
    private fb: FormBuilder,
    private router: Router,
    private message: MessageService
  ) { }

  ngOnInit() {

    //Recupero Dto
    this.importService.getImportFields().subscribe(res => this.importGiftFields = res);

    this.form = this.fb.group({
      description: ['']
    });

  }

  onMovementFileUpload(event) {
    if (event.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    } else {
      this.giftFile = event.files[0];
      this.fileName = this.giftFile.name;
    }
  }

  imageFileUpload(event) {
    for(let i = 0; i < event.files.length; i++ ){
      let index = this.imageFile.indexOf(event.files[i]);
      if (index == -1){
        this.imageFile.push(event.files[i]);
      }
      console.log(this.imageFile);
    }
  }
  get f() {
    return this.form.controls;
  }

  import() {
    if (
      KoncentroValidators.isEmptyInputValue(this.f.description.value)
    ) {
      this.invalidSubmit = true;
      this.f.description.setErrors({ 'invalid': true });
    }

    this.invalidSubmit = false;

    const data: FormData = new FormData;
    data.append('description', this.form.get('description').value);
    data.append('fileXls', this.giftFile, this.fileName);

    for (let file of this.imageFile) {
      data.append('fileZip', file, file.name);
  }

    this.importService.importCatalog(data).subscribe(() => {
      this.message.add({ severity: 'success', summary: 'Success', detail: 'Import Succesful' })
      this.router.navigate(['/loyalty/import-gift']);
    });

    this.giftFile = null;

  }

  getSizeInMegaBytes(file: File) {
    return file ? file.size / 1000000 : 0;
}

removeFile(file: File, uploader: FileUpload ) {
    const index = uploader.files.indexOf(file);
    uploader.remove(event, index);
    this.giftFile = null;
}

removeFileImage(file: File, uploader: FileUpload ) {
  const index = uploader.files.indexOf(file);
  uploader.remove(event, index);
  const i = this.imageFile.indexOf(file);
  this.imageFile.splice(i)
}

closeDialog() {
  this.imagesNotPresent = false;
}

controlFile() {
  if(this.giftFile && this.imageFile.length > 0) {
    this.import();
  } else {
    this.imagesNotPresent = true;
  }
}

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/loyalty-import-gift-detail/loyalty-import-gift-detail.component.ts